import PropTypes from 'prop-types';

import {onSearchParamsChange, onPageUpdate} from '../../services/targeting';
import {MesoAdsContext} from '../MesoAdsContext/MesoAdsContext';
import {shouldAdsRefresh} from "../../utils/need-ads-refresh";
import isEqual from 'lodash.isequal';

export class MesoAdsContextWithSearchParams extends MesoAdsContext {

    static getDerivedStateFromProps(props, state) {
        const newState = {};
        if (props.gaiaId !== state.gaiaId) {
            newState.gaiaId = props.gaiaId;
        }

        if (!isEqual(props.searchParams, state.latestSearchParams)) {
            newState.staleSearchParams = state.latestSearchParams || {};
            newState.latestSearchParams = props.searchParams || {};
        }

        if (Object.keys(newState).length) {
            newState.needsUpdate = true;
            return newState;
        }

        return null;
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        super.componentDidMount();
        if (this.state.isBrowser) {
            const {latestSearchParams={}} = this.state
            const {gaiaId} = this.props;
            onSearchParamsChange({gaiaId, searchParams: latestSearchParams});
        }
    }

    componentDidUpdate(prevProps) {
        if (this.state.isBrowser) {
            const {staleSearchParams, gaiaId, needsUpdate, latestSearchParams={}} = this.state
            if (
                needsUpdate && 
                (prevProps.gaiaId !== gaiaId || shouldAdsRefresh(staleSearchParams.params, latestSearchParams.params))
            ) {
                this.setState({needsUpdate:false});
                onSearchParamsChange({gaiaId, searchParams: latestSearchParams});
            }
        }
    }
}

MesoAdsContextWithSearchParams.defaultProps = {
    searchParams: {}
};

MesoAdsContextWithSearchParams.propTypes = {
    ...MesoAdsContext.propTypes,
    // Represent data from search filters
    searchParams: PropTypes.shape({
        pathname: PropTypes.string,
        params: PropTypes.shape({
            q: PropTypes.string,
            zoom: PropTypes.number,
            neLat: PropTypes.number,
            swLat: PropTypes.number,
            swLong: PropTypes.number
        }),
        prevParams: PropTypes.shape({
            q: PropTypes.string,
            zoom: PropTypes.number,
            neLat: PropTypes.number,
            swLat: PropTypes.number,
            swLong: PropTypes.number
        })

    }).isRequired
};

